import { z } from "zod"

export const payrollProfileStateV1Schema = z.enum([
  "in_progress",
  "complete",
  "action_required",
])

const maskedSummarySchema = z.enum([
  "not_provided",
  "ending_00",
  "ending_000",
  "ending_0000",
]).or(z.string().regex(/^ending_[A-Za-z0-9]{2,4}$/))

export const employeePayrollProfileSyncV1Schema = z
  .object({
    requestVersion: z.literal(1),
    correlationId: z.string().uuid(),
    idempotencyKey: z.string().min(8).max(128),
    expectedVersion: z.number().int().nonnegative(),
    profileId: z.string().uuid(),
    workerId: z.string().uuid(),
    employmentId: z.string().uuid(),
    legalEntityId: z.string().uuid(),
    providerEmployeeId: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
    state: payrollProfileStateV1Schema,
    maskedTaxSummary: maskedSummarySchema,
    maskedBankSummary: maskedSummarySchema,
  })
  .strict()

export const employeePayrollProfileResultV1Schema = z
  .object({
    entityType: z.literal("employee_payroll_profile"),
    entityId: z.string().uuid(),
    state: payrollProfileStateV1Schema,
    version: z.number().int().positive(),
    workerId: z.string().uuid(),
    employmentId: z.string().uuid(),
    legalEntityId: z.string().uuid(),
    providerEmployeeRef: z.string().regex(/^[a-f0-9]{16}$/),
    maskedTaxSummary: maskedSummarySchema,
    maskedBankSummary: maskedSummarySchema,
    sensitiveDataStored: z.literal(false),
  })
  .strict()

export type EmployeePayrollProfileSyncV1 = z.infer<
  typeof employeePayrollProfileSyncV1Schema
>
export type EmployeePayrollProfileResultV1 = z.infer<
  typeof employeePayrollProfileResultV1Schema
>
